import * as st from './styles.module.scss';

interface Props {
  image?: string;
  description: string;
}

export const Description = ({ image, description }: Props): JSX.Element => {
  const formattedDescription = description.replace(/\r\n|\n|\r/g, '<br />');

  return (
    <div className={st.description}>
      <img src={image} alt="" />
      <p dangerouslySetInnerHTML={{ __html: formattedDescription }}></p>
    </div>
  );
};
